<template>
  <div class="menu-se-connecter">
    <router-link to="/signin"
                 title="Se connecter à votre compte COOLOC">
      <svgicon icon="profile-user" class="connect-icon"></svgicon>
      <span>Se connecter</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'header-menu-signin',
}
</script>
